import { SelectProps } from 'antd/lib'

import { useLocales } from 'src/locales'

export const useConfig = () => {
  const { t } = useLocales()

  const options: SelectProps['options'] = [
    {
      value: '',
      label: 'Implicit'
    },
    {
      value: 'Name',
      label: t('notification_templates.name_asc')
    },
    {
      value: '-Name',
      label: t('notification_templates.name_desc')
    },
    {
      value: 'EventName',
      label: t('notification_templates.event_asc')
    },
    {
      value: '-EventName',
      label: t('notification_templates.event_desc')
    }
  ]

  return { options }
}
